import React from "react";
import { useParams } from "react-router-dom";
import RootShortcutPortfolioHash from "container/shortcutPortfolio/RootShortcutPortfolioHash";
import AppUpdateCheckpoint from "container/common/AppUpdateCheckpoint";

function ShortcutPortfolioHashPage(props) {
  const params = useParams();

  return (
    <AppUpdateCheckpoint>
      <RootShortcutPortfolioHash userHash={params.userHash} />
    </AppUpdateCheckpoint>
  );
}

export default ShortcutPortfolioHashPage;
